export default "__VITE_ASSET__7068686e__"